import { ButtonGeneral, ButtonSecondary, theme } from '@by-miles/bymiles-styles'

interface PlayButton {
  onClick: () => void
}

export const PlayAgainButton = ({ onClick }: PlayButton) => {
  return (
    <ButtonSecondary
      label="Play again"
      backgroundColor={theme.primaryColours.white.main}
      onClick={onClick}
      dataCy="play-again"
      customIcon="IconRefresh"
    />
  )
}

export const PlayNextButton = ({ onClick }: PlayButton) => {
  return <ButtonGeneral label="Play next" onClick={onClick} dataCy="play-next" icon="IconRoundedPlayButton" />
}
